import $ from 'jquery'

function preprocess() {
	let num = $('.movie-item-box').length;
	console.log(num);
	let even = num / 2;
	let odd = (num + 1) / 2;

	if (num % 2 == 0) {
		$('.movie-item-box:nth-child(' + even + ')').addClass('active');
		$('.movie-item-box:nth-child(' + even + ')').prev().addClass('prev');
		$('.movie-item-box:nth-child(' + even + ')').next().addClass('next');
	} else {
		$('.movie-item-box:nth-child(' + odd + ')').addClass('active');
		$('.movie-item-box:nth-child(' + odd + ')').prev().addClass('prev');
		$('.movie-item-box:nth-child(' + odd + ')').next().addClass('next');
	}
}
export const movieCardAnimation = () => {
	$('.movie-item-box').click(function () {
		//preprocess();
		let slide = $('.active').width();
		console.log("slide", slide)
		//console.log("active pos", $('.active').position().left);
		//if ($(this).hasClass('next')) {
		//	$('.card-carousel').stop(false, true).animate({ left: '-=' + slide });
		// } else if
		//  ($(this).hasClass('prev')) {
		// 	$('.card-carousel').stop(false, true).animate({ left: '+=' + slide });
		// }

		$(this).removeClass('prev next');
		$(this).siblings().removeClass('prev active next');

		$(this).addClass('active');
		$(this).prev().addClass('prev');
		$(this).next().addClass('next');
	});
	$('html body').keydown(function (e) {
		if (e.keyCode == 37) { // left
			$('.active').prev().trigger('click');
		}
		else if (e.keyCode == 39) { // right
			$('.active').next().trigger('click');
		}
	});
}